import { render, staticRenderFns } from "./BusinessMemberPrescription.vue?vue&type=template&id=42a811ee"
import script from "./BusinessMemberPrescription.vue?vue&type=script&lang=js"
export * from "./BusinessMemberPrescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports